import * as Sentry from '@sentry/react';

const logger = {};
logger.info = function wrapInfo(message, extraInfo) {
  console.log(message); // eslint-disable-line no-console
  Sentry.withScope((scope) => {
    if (extraInfo) {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in extraInfo) {
        if (key) {
          scope.setExtra(key, extraInfo[key]);
        }
      }
    }
    Sentry.captureMessage(message, 'info');
  });
};

logger.error = function wrapError(error, extraInfo) {
  console.log(error, extraInfo, 'ERROR'); // eslint-disable-line no-console
  Sentry.withScope((scope) => {
    if (extraInfo) {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in extraInfo) {
        if (key) {
          scope.setExtra(key, extraInfo[key]);
        }
      }
    }
    Sentry.captureException(new Error(error));
  });
};

logger.warn = function wrapWarn(message, extraInfo) {
  console.log(message); // eslint-disable-line no-console
  Sentry.withScope((scope) => {
    if (extraInfo) {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in extraInfo) {
        if (key) {
          scope.setExtra(key, extraInfo[key]);
        }
      }
    }
    Sentry.captureMessage(message, 'warning');
  });
};

export default logger;
